<template>
  <el-card>
    <el-row class="common-margin">
      <el-row>
        <el-col :span="12">
          <el-button
              class="btns-add"
              icon="el-icon-plus"
              size="medium"
              @click="add"
              v-if="isShowEnroll"
          >添加产品</el-button
          >
        </el-col>
      </el-row>
      <el-table
          :data="tableData"
          :max-height="tableHeight"
          style="width: 100%; margin-bottom: 20px; margin-top: 20px"
          border
      >
        <el-table-column type="index" width="80px" align="center" label="序号"> </el-table-column>
        <el-table-column prop="compositeName" align="center" label="名称"></el-table-column>
        <el-table-column prop="title" align="center" label="logo">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.logoSrc"
                style="height: 100px"
                :src="scope.row.logoSrc"
                :preview-src-list="scope.row.logoList"
                fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="picture" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.pictureSrc"
                style="height: 100px;"
                :src="scope.row.pictureSrc"
                :preview-src-list="scope.row.pictureList"
                fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="category" align="center" label="品类"> </el-table-column>
        <el-table-column prop="address" align="center" label="地址"> </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                @click="handleDelete(scope.row.id)"
            >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes"
          :total="total"
      >
      </el-pagination>
    </el-row>
  </el-card>
</template>

<script>

export default {
  name: 'index',
  props: ['isShowEnroll'],
  data () {
    return {
      id: '',
      tableData: [],
      tableHeight: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 320
  },
  methods: {
    async getPageList (id) {
      this.id = id
      this.tableData = []
      this.total = 0
      let {data: res} = await this.$http.post('/boutiqueActivities/boutiqueActivities/getActivityRegistrationList', {
        activityId: id,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach(item => {
          if (item.logo) {
            item.logoList = item.logo.split(',')
            item.logoSrc = item.logo.split(',')[0]
          } else {
            item.logoSrc = ''
            item.logoList = []
          }
          if (item.picture) {
            item.pictureList = item.picture.split(',')
            item.pictureSrc = item.picture.split(',')[0]
          } else {
            item.pictureSrc = ''
            item.pictureList = []
          }
        })
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    add () {
      this.$emit('isShowActivity', this.id)
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList(this.id)
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList(this.id)
    },
    handleDelete (id) {
      this.$confirm('此操作将取消参加该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/boutiqueActivities/boutiqueActivities/batchDelete', {ids: id}).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList(this.id)
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/exhibitionActivity/bannerAndAdvertIndex.vue